import request from '@/core/http/request'

// 新增仓库信息
export function warehouse_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/add',
    method: 'post',
    data: data
  })
}

// 查询仓库信息
export function warehouse_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/list',
    method: 'post',
    data: data
  })
}

// 查询详细仓库信息
export function warehouse_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/view',
    method: 'get',
    params: data
  })
}

// 查询仓位信息
export function warehousePosition_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehousePosition/list',
    method: 'post',
    data: data
  })
}

// 新增仓位信息
export function warehousePosition_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehousePosition/add',
    method: 'post',
    data: data
  })
}

// 删除仓位信息
export function warehousePosition_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehousePosition/delete',
    method: 'post',
    data: data
  })
}

// 修改仓位信息
export function warehousePosition_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehousePosition/update',
    method: 'post',
    data: data
  })
}

// 仓位信息详情
export function warehousePosition_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehousePosition/view',
    method: 'get',
    params: data
  })
}

// 删除仓库信息
export function warehouse_del(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/delete',
    method: 'post',
    data: data
  })
}

// 修改仓库信息
export function warehouse_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/update',
    method: 'post',
    data: data
  })
}

// 新增仓库订单
export function warehouseOtherDoc_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOtherDoc/add',
    method: 'post',
    data: data
  })
}

// 删除仓库订单
export function warehouseOtherDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOtherDoc/delete',
    method: 'post',
    data: data
  })
}

// 详细页面 审核
export function warehouseOtherDoc_checkWarehouseOtherDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOtherDoc/checkWarehouseOtherDoc',
    method: 'post',
    data: data
  })
}

// 查询仓库订单
export function warehouseOtherDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOtherDocDetail/wareOtherDocList',
    method: 'post',
    data: data
  })
}

// 修改仓库订单
export function warehouseOtherDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOtherDoc/update',
    method: 'post',
    data: data
  })
}

// 修改日期
export function warehouseOtherDoc_updateOperaDate(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOtherDoc/updateOperaDate',
    method: 'post',
    data: data
  })
}

// 审核仓库订单
export function warehouseOtherDoc_check(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOtherDoc/check',
    method: 'post',
    data: data
  })
}

// 出入库打印数据
export function getWarehouseOtherDocDetailByDocIdForPrint(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOtherDocDetail/getWarehouseOtherDocDetailByDocIdForPrint',
    method: 'post',
    data: data
  })
}

// 库存汇总
export function getWarehouseStockTotal(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getWarehouseStockTotal',
    method: 'post',
    data: data
  })
}

// 库存查询
export function warehouseInventory_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getWarehouseInventoryByFilter',
    method: 'post',
    data: data
  })
}

// 库存查询（包含在制数量）
export function tenantCustom_getInventoryWithProcessStatus(data) {
  return request({
    url: '/qingguang/tenantbussiness/tenantCustom/getInventoryWithProcessStatus',
    method: 'post',
    data: data
  })
}

// 库存查询汇总（包含在制数量）
export function tenantCustom_getInventoryWithProcessStatusSummary(data) {
  return request({
    url: '/qingguang/tenantbussiness/tenantCustom/getInventoryWithProcessStatusSummary',
    method: 'post',
    data: data
  })
}

// 批量库存查询
export function warehouseInventory_batchQueryWareStock(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/batchQueryWareStock',
    method: 'post',
    data: data
  })
}

// 库存流水查询
export function warehouseInventoryFlow_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryFlow/listByFilter',
    method: 'post',
    data: data
  })
}

// 根据仓库ID库存流水查询
export function warehouseInventoryFlow_listById(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryFlow/listByWarehouseId',
    method: 'post',
    data: data
  })
}

// 查询是否可以出库
export function warehouseOutRight(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/canExitWarehouseByList',
    method: 'post',
    data: data
  })
}

// 仓库数据概览
export function getWarehouseDataInfo(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getWarehouseDataInfo',
    method: 'post',
    data: data
  })
}

// 产品入库排行
export function getProductInboundRank(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getProductInboundRank',
    method: 'post',
    data: data
  })
}

// 产品出库排行
export function getProductOutboundRank(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getProductOutboundRank',
    method: 'post',
    data: data
  })
}

// 滞留时间排行
export function getProductRetentionRank(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getProductRetentionRank',
    method: 'post',
    data: data
  })
}

// 单个物料库存查询
export function warehouseInventory_getWarehouseInventoryAccount(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getWarehouseInventoryAccount',
    method: 'post',
    data: data
  })
}

// 出库台账
export function ledger_query(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOutboundLedger/outboundLedgerList',
    method: 'post',
    data: data
  })
}

// 其他出入库详细
export function warehouseOtherDocDetail_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOtherDoc/viewById',
    method: 'get',
    params: data
  })
}

// 新增库存预警
export function warehouseInventoryAlert_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryAlert/saveNewOrUpdateBatch',
    method: 'post',
    data: data
  })
}

// 库存预警判断是否重复
export function warehouseInventoryAlert_existsMaterialAlert(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryAlert/existsMaterialAlert',
    method: 'post',
    data: data
  })
}

// 查询库存预警
export function warehouseInventoryAlert_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryAlert/listAlert',
    method: 'post',
    data: data
  })
}

// 修改库存预警
export function warehouseInventoryAlert_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryAlert/update',
    method: 'post',
    data: data
  })
}

// 删除库存预警
export function warehouseInventoryAlert_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryAlert/delete',
    method: 'post',
    data: data
  })
}

// 仓库调拨新增
export function warehouseDispatchDoc_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDispatchDoc/add',
    method: 'post',
    data: data
  })
}

// 仓库调拨审核
export function warehouseDispatchDoc_checkWarehouseDispatchDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDispatchDoc/checkWarehouseDispatchDoc',
    method: 'post',
    data: data
  })
}

// 仓库调拨修改
export function warehouseDispatchDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDispatchDoc/update',
    method: 'post',
    data: data
  })
}

// 仓库调拨查询
export function warehouseDispatchDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDispatchDoc/listWithRelation',
    method: 'post',
    data: data
  })
}

// 仓库调拨删除
export function warehouseDispatchDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDispatchDoc/delete',
    method: 'post',
    data: data
  })
}

// 仓库调拨查询详情
export function warehouseDispatchDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDispatchDoc/view',
    method: 'get',
    params: data
  })
}

// 查询物流
export function logistics_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/logistics/list',
    method: 'post',
    data: data
  })
}

// 新增物流
export function logistics_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/logistics/add',
    method: 'post',
    data: data
  })
}

// 修改物流
export function logistics_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/logistics/update',
    method: 'post',
    data: data
  })
}

// 删除物流
export function logistics_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/logistics/delete',
    method: 'post',
    data: data
  })
}

// 新增物流单
export function logisticsOrderDoc_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/logisticsOrderDoc/add',
    method: 'post',
    data: data
  })
}

// 查询物流单
export function logisticsOrderDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/logisticsOrderDoc/list',
    method: 'post',
    data: data
  })
}

// 修改物流单
export function logisticsOrderDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/logisticsOrderDoc/update',
    method: 'post',
    data: data
  })
}

// 删除物流单
export function logisticsOrderDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/logisticsOrderDoc/delete',
    method: 'post',
    data: data
  })
}

// 查询物流单详情
export function logisticsOrderDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/logisticsOrderDoc/view',
    method: 'get',
    params: data
  })
}

// 根据关联单ID查询物料单信息
export function logisticsOrderDoc_getLogisticsOrderDocByDocId(data) {
  return request({
    url: '/qingguang/tenantbussiness/logisticsOrderDoc/getLogisticsOrderDocByDocId',
    method: 'post',
    data: data
  })
}

// 待入库
export function warehouse_getWarehouseDocList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getWarehouseDocList',
    method: 'post',
    data: data
  })
}

// 新增仓库报废
export function warehouseMaterialScrapDoc_addList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseMaterialScrapDoc/addList',
    method: 'post',
    data: data
  })
}

// 新增仓库报废
export function warehouseMaterialScrapDoc_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseMaterialScrapDoc/add',
    method: 'post',
    data: data
  })
}

// 查询仓库报废
export function warehouseMaterialScrapDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseMaterialScrapDoc/selectWarehouseMaterialScrapDocList',
    method: 'post',
    data: data
  })
}

// 删除仓库报废
export function warehouseMaterialScrapDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseMaterialScrapDoc/delete',
    method: 'post',
    data: data
  })
}

// 审核仓库报废
export function warehouseMaterialScrapDoc_mergeWarehouseMaterialScrapDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseMaterialScrapDoc/mergeWarehouseMaterialScrapDoc',
    method: 'post',
    data: data
  })
}

// 查询仓库报废详情
export function warehouseMaterialScrapDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseMaterialScrapDoc/view',
    method: 'get',
    params: data
  })
}

// 修改仓库报废
export function warehouseMaterialScrapDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseMaterialScrapDoc/update',
    method: 'post',
    data: data
  })
}

// 查询库龄
export function warehouseInventoryFlow_listByStockageQuery(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryFlow/listByStockageQuery',
    method: 'post',
    data: data
  })
}

// 库存汇总
export function warehouseInventory_getListByFilter(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getListByFilter',
    method: 'post',
    data: data
  })
}

// 查询仓库配置
export function sysOutInWmsSetting_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysOutInWmsSetting/list',
    method: 'post',
    data: data
  })
}

// 修改仓库配置
export function sysOutInWmsSetting_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysOutInWmsSetting/update',
    method: 'post',
    data: data
  })
}

// 根据key查询仓库配置
export function sysOutInWmsSetting_getWMSSettingByTypeId(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysOutInWmsSetting/getWMSSettingByTypeId',
    method: 'get',
    params: data
  })
}

// 平账
export function warehouseOutboundLedger_warehouseBalanceAccount(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOutboundLedger/warehouseBalanceAccount',
    method: 'post',
    data: data
  })
}

// 库存盘点
export function warehouseInventory_updateWmsInventory(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/updateWmsInventory',
    method: 'post',
    data: data
  })
}

// 产品库存分布
export function warehouseInventory_getMaterialOutboundWarehouse(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getMaterialOutboundWarehouse',
    method: 'post',
    data: data
  })
}

// 组装产品 提交
export function assembleDisassemblyDoc_assembleProduce(data) {
  return request({
    url: '/qingguang/tenantbussiness/assembleDisassemblyDoc/assembleProduce',
    method: 'post',
    data: data
  })
}

// 组装产品 查询整体
export function assembleDisassemblyDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/assembleDisassemblyDoc/list',
    method: 'post',
    data: data
  })
}

// 组装产品 删除数据
export function assembleDisassemblyDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/assembleDisassemblyDoc/delete',
    method: 'post',
    data: data
  })
}

// 组装产品 详情
export function assembleDisassemblyDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/assembleDisassemblyDoc/view',
    method: 'get',
    params: data
  })
}

// 组装产品 审核通过
export function assembleDisassemblyDoc_checkAssembleDisassembly(data) {
  return request({
    url: '/qingguang/tenantbussiness/assembleDisassemblyDoc/checkAssembleDisassembly',
    method: 'post',
    data: data
  })
}

// 组装产品 取消审核
export function assembleDisassemblyDoc_cancellCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/assembleDisassemblyDoc/cancellCheck',
    method: 'post',
    data: data
  })
}

// 组装产品 修改
export function assembleDisassemblyDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/assembleDisassemblyDoc/update',
    method: 'post',
    data: data
  })
}
export function assembleDisassemblyDocSalary_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/assembleDisassemblyDocSalary/update',
    method: 'post',
    data: data
  })
}

// 拆卸产品 提交
export function assembleDisassemblyDoc_disassembleProduce(data) {
  return request({
    url: '/qingguang/tenantbussiness/assembleDisassemblyDoc/disassembleProduce',
    method: 'post',
    data: data
  })
}

// 库存锁定 查询
export function warehouseInventoryLock_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryLock/list',
    method: 'post',
    data: data
  })
}

// 库存锁定 手动释放
export function warehouseInventoryLock_unLockInventory(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryLock/unLockInventory',
    method: 'post',
    data: data
  })
}

// 库存锁定 批量释放
export function warehouseInventoryLock_batchUnLockInventory(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryLock/batchUnLockInventory',
    method: 'post',
    data: data
  })
}

// 物流记录查询（快递物流）
export function logisticsOrderDoc_checkOrder(data) {
  return request({
    url: '/qingguang/tenantbussiness/logisticsOrderDoc/checkOrder',
    method: 'post',
    data: data
  })
}

// 产品溯源
export function proddocFinishtowarehouse_traceSource(data) {
  return request({
    url: '/qingguang/tenantbussiness/proddocFinishtowarehouse/traceSource',
    method: 'post',
    data: data
  })
}

// 查询库存，返回每个批次号当前剩余的数量，用于前端来选择从哪个批次出, 仓库id 可以不传，不传就是全部仓库
export function warehouseInventory_queryBatchNumberInventoryBySpecGroupId(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/queryBatchNumberInventoryBySpecGroupId',
    method: 'post',
    data: data
  })
}

// 根据批次号的关联单据ID查询关联关系
export function traceBatchAssemblySplitting_getBatchSplittingAndAssemblyRecords(data) {
  return request({
    url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/traceBatchAssemblySplitting/getBatchSplittingAndAssemblyRecords',
    method: 'post',
    data: data
  })
}

// 库存盘点审核模块
// 查询list
export function wmsStocktakingDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/wmsStocktakingDoc/list',
    method: 'post',
    data: data
  })
}

// 修改update
export function wmsStocktakingDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/wmsStocktakingDoc/update',
    method: 'post',
    data: data
  })
}

// 删除delete
export function wmsStocktakingDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/wmsStocktakingDoc/delete',
    method: 'post',
    data: data
  })
}

// 详情view
export function wmsStocktakingDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/wmsStocktakingDoc/view',
    method: 'get',
    params: data
  })
}

// 审核 check
export function wmsStocktakingDoc_check(data) {
  return request({
    url: '/qingguang/tenantbussiness/wmsStocktakingDoc/check',
    method: 'post',
    data: data
  })
}

// 取消审核 uncheck
export function wmsStocktakingDoc_uncheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/wmsStocktakingDoc/uncheck',
    method: 'post',
    data: data
  })
}

// 仓库月度报表 list
export function wmsWarehouseMonthReport_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/wmsWarehouseMonthReport/list',
    method: 'post',
    data: data
  })
}

// 仓库年度报表 转结
export function wmsWarehouseMonthReport_carryForward(data) {
  return request({
    url: '/qingguang/tenantbussiness/wmsWarehouseMonthReport/carryForward',
    method: 'post',
    data: data
  })
}

// 仓库年度报表 反转结
export function wmsWarehouseMonthReport_rollbackCarryForward(data) {
  return request({
    url: '/qingguang/tenantbussiness/wmsWarehouseMonthReport/rollbackCarryForward',
    method: 'post',
    data: data
  })
}

// 仓库年度报表 重新生成上月报表
export function wmsWarehouseMonthReport_reGenerateReport(data) {
  return request({
    url: '/qingguang/tenantbussiness/wmsWarehouseMonthReport/reGenerateReport',
    method: 'post',
    data: data
  })
}

// 让步接收单 列表list
export function proddocAcceptDeviationDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/proddocAcceptDeviationDoc/list',
    method: 'post',
    data: data
  })
}

// 让步接收单 批量审核
export function proddocAcceptDeviationDoc_checkAcceptDeviationDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/proddocAcceptDeviationDoc/checkAcceptDeviationDoc',
    method: 'post',
    data: data
  })
}

// 仓位库存查询
export function wmsInventoryPosition_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/wmsInventoryPosition/list',
    method: 'post',
    data: data
  })
}

// 仓位调拨 查询
export function wmsDispatchPositionDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/wmsDispatchPositionDoc/list',
    method: 'post',
    data: data
  })
}

// 仓位调拨 新增
export function wmsDispatchPositionDoc_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/wmsDispatchPositionDoc/add',
    method: 'post',
    data: data
  })
}

// 仓位调拨 详细
export function wmsDispatchPositionDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/wmsDispatchPositionDoc/view',
    method: 'get',
    params: data
  })
}

// 仓位调拨 审核
export function wmsDispatchPositionDoc_checkWarehouseDispatchDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/wmsDispatchPositionDoc/checkWarehouseDispatchDoc',
    method: 'post',
    data: data
  })
}

// 仓位调拨 删除
export function wmsDispatchPositionDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/wmsDispatchPositionDoc/delete',
    method: 'post',
    data: data
  })
}

// 仓位调拨 更新
export function wmsDispatchPositionDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/wmsDispatchPositionDoc/update',
    method: 'post',
    data: data
  })
}

// 不良品操作新增
export function warehouseDefectiveOperation_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDefectiveOperation/add',
    method: 'post',
    data: data
  })
}

// 不良品操作修改
export function warehouseDefectiveOperation_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDefectiveOperation/update',
    method: 'post',
    data: data
  })
}

// 不良品操作删除
export function warehouseDefectiveOperation_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDefectiveOperation/delete',
    method: 'post',
    data: data
  })
}

// 不良品操作列表
export function warehouseDefectiveOperation_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDefectiveOperation/list',
    method: 'post',
    data: data
  })
}

// 不良品操作新增
export function warehouseDefectiveOperation_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDefectiveOperation/view',
    method: 'get',
    params: data
  })
}

// 不良品操作审核
export function warehouseDefectiveOperation_checkOrCancel(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseDefectiveOperation/checkOrCancel',
    method: 'post',
    data: data
  })
}

// 库存流水，库存价值修改
export function warehouseInventoryFlow_changeInventorFlowUnitPrice(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryFlow/changeInventorFlowUnitPrice',
    method: 'post',
    data: data
  })
}

// 根据流水记录分组查询库存
export function warehouseInventory_getWarehouseInventoryFlowGroupByBatch(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getWarehouseInventoryFlowGroupByBatch',
    method: 'post',
    data: data
  })
}

// 批次管理 汇总数据
export function warehouseInventory_getWarehouseInventoryFlowSummary(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getWarehouseInventoryFlowSummary',
    method: 'post',
    data: data
  })
}

// 其他出入库的统计
export function warehouseOtherDocDetail_wareOtherDocSummary(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseOtherDocDetail/wareOtherDocSummary',
    method: 'post',
    data: data
  })
}

// 获取仓库侧边栏的数据
export function warehouse_getWarehouseDocListSum(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getWarehouseDocListSum',
    method: 'post',
    data: data
  })
}

// 销售换货单待出库
export function warehouse_getSalesBarterDocWaitToOutBoundList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getSalesBarterDocWaitToOutBoundList',
    method: 'post',
    data: data
  })
}

// 采购换货单待出库
export function warehouse_getPurchasesBarterDocWaitToOutBoundList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getPurchasesBarterDocWaitToOutBoundList',
    method: 'post',
    data: data
  })
}

// 工序委外换货单待出库
export function warehouse_getProcessOutsourcingBarterDocWaitToOutBoundList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getProcessOutsourcingBarterDocWaitToOutBoundList',
    method: 'post',
    data: data
  })
}

// 委外退货待出库
export function warehouse_getOutsourcingChargebackDocWaitToOutBoundList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getOutsourcingChargebackDocWaitToOutBoundList',
    method: 'post',
    data: data
  })
}

// 工序委外退货待出库
export function warehouse_getProcessOutsourcingChargebackDocWaitToOutBoundList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getProcessOutsourcingChargebackDocWaitToOutBoundList',
    method: 'post',
    data: data
  })
}

// 委外换货待出库
export function warehouse_getOutsourcingBarterDocWaitToOutBoundList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getOutsourcingBarterDocWaitToOutBoundList',
    method: 'post',
    data: data
  })
}

// 销售换货待入库
export function warehouse_getSalesBarterDocWaitToInBoundList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getSalesBarterDocWaitToInBoundList',
    method: 'post',
    data: data
  })
}

// 采购换货待入库
export function warehouse_getPurchasesBarterDocWaitToInBoundList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getPurchasesBarterDocWaitToInBoundList',
    method: 'post',
    data: data
  })
}

// 工序委外换货待入库
export function warehouse_getProcessOutsourcingBarterDocWaitToInBoundList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getProcessOutsourcingBarterDocWaitToInBoundList',
    method: 'post',
    data: data
  })
}

// 委外换货待入库
export function warehouse_getOutsourcingBarterDocWaitToInBoundList(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouse/getOutsourcingBarterDocWaitToInBoundList',
    method: 'post',
    data: data
  })
}

// 仓库库存底部数据
export function warehouseInventory_getWarehouseInventoryByFilterSum(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getWarehouseInventoryByFilterSum',
    method: 'post',
    data: data
  })
}

// 线边仓流水查询
export function produceWarehouseFlow_listByProduceWarehouseId(data) {
  return request({
    url: '/qingguang/tenantbussiness/produceWarehouseFlow/listByProduceWarehouseId',
    method: 'post',
    data: data
  })
}

// 委外仓流水查询
export function outsourcingWarehouseFlow_listByOutsourcingWarehouseId(data) {
  return request({
    url: '/qingguang/tenantbussiness/outsourcingWarehouseFlow/listByOutsourcingWarehouseId',
    method: 'post',
    data: data
  })
}

// 批次号/仓位选择
export function warehouseInventory_queryPositionInventoryByBatchNumber(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/queryPositionInventoryByBatchNumber',
    method: 'post',
    data: data
  })
}

// 流水重算
export function warehouseInventoryFlow_recalculateInventoryFlowValues(data, params) {
  return request({ 
    url: '/qingguang/tenantbussiness/warehouseInventoryFlow/recalculateInventoryFlowValues' + '?inventoryId=' + params.params.inventoryId,
    method: 'post',
    data: data
  })
}

// 查看副单位数量
export function warehouseInventory_getInventoryByUnit(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/getInventoryByUnit',
    method: 'post',
    data: data
  })
}

// 箱体配置 list
export function packBox_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/packBox/list',
    method: 'post',
    data: data
  })
}

// 箱体配置 add
export function packBox_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/packBox/add',
    method: 'post',
    data: data
  })
}

// 箱体配置 view
export function packBox_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/packBox/view',
    method: 'get',
    params: data
  })
}

// 箱体配置 update
export function packBox_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/packBox/update',
    method: 'post',
    data: data
  })
}

// 箱体配置 delete
export function packBox_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/packBox/delete',
    method: 'post',
    data: data
  })
}

// 规则管理 list 
export function packRule_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/packRule/list',
    method: 'post',
    data: data
  })
}

// 规则管理 add
export function packRule_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/packRule/add',
    method: 'post',
    data: data
  })
}

// 规则管理 view
export function packRule_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/packRule/view',
    method: 'get',
    params: data
  })
}

// 规则管理 update
export function packRule_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/packRule/update',
    method: 'post',
    data: data
  })
}

// 规则管理 delete
export function packRule_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/packRule/delete',
    method: 'post',
    data: data
  })
}

// 装箱单 list
export function packDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/packDoc/list',
    method: 'post',
    data: data
  })
}

// 装箱单 add
export function packDoc_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/packDoc/add',
    method: 'post',
    data: data
  })
}

// 装箱单 view
export function packDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/packDoc/view',
    method: 'get',
    params: data
  })
}

// 装箱单 update
export function packDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/packDoc/update',
    method: 'post',
    data: data
  })
}

// 装箱单 delete
export function packDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/packDoc/delete',
    method: 'post',
    data: data
  })
}

// 装箱单审核
export function packDoc_check(data) {
  return request({
    url: '/qingguang/tenantbussiness/packDoc/check',
    method: 'post',
    data: data
  })
}

// 查询产品属性
export function warehouseInventory_queryProductVariantAggPage(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventory/queryProductVariantAggPage',
    method: 'post',
    data: data
  })
}

// 查询库存流水关联属性子流水
export function warehouseInventoryFlow_getFlowVariantListByFlowId(data) {
  return request({
    url: '/qingguang/tenantbussiness/warehouseInventoryFlow/getFlowVariantListByFlowId',
    method: 'post',
    data: data
  })
}